module.exports = __webpack_public_path__ + "static/media/politica-venta.3ac1c52f.pdf";